
import { Component, Input, OnInit } from '@angular/core';

import { RolInterface } from '@semantics/interfaces/Rol';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  @Input() rol : RolInterface;

  constructor() { }

  ngOnInit(): void {

    console.log(this.rol);
  }

}
